import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { BookingComponent } from './features/booking/booking.component';
import { SettingsComponent } from './features/settings/settings.component';
import { LoginComponent } from './features/login/login.component';
import { ProfessionalComponent } from './features/professional/professional.component';
import { ConfirmBookingComponent } from './features/confirm-booking/confirm-booking.component';
import { MyAppointmentsComponent } from './features/my-appointments/my-appointments.component';
import { PublicBookingComponent } from './features/public-booking/public-booking.component';
import { AvailabilityComponent } from './features/availability/availability.component';
import { OnboardingComponent } from './features/onboarding/onboarding.component';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';

const routes: Routes = [
  { path: '',                     redirectTo: 'login', pathMatch: 'full' },
  { path: 'login',                component: LoginComponent },
  { path: 'book/:professionalId', component: PublicBookingComponent },
  { path: 'dashboard',            component: DashboardComponent,      canActivate: [AuthGuard] },
  { path: 'booking',              component: BookingComponent,        canActivate: [AuthGuard] },
  { path: 'my-appointments',      component: MyAppointmentsComponent, canActivate: [AuthGuard] },
  { path: 'availability',         component: AvailabilityComponent,   canActivate: [AuthGuard] },
  { path: 'onboarding',           component: OnboardingComponent,     canActivate: [AuthGuard] },
  { path: 'settings',             component: SettingsComponent,       canActivate: [AuthGuard] },
  { path: 'professional',         component: ProfessionalComponent,   canActivate: [AuthGuard, RoleGuard] },
  { path: 'confirm-booking',      component: ConfirmBookingComponent, canActivate: [AuthGuard] },
  { path: '**',                   redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
